<script lang="ts" setup>
import { MainMenu } from './useMainMenu'
withDefaults(
  defineProps<{
    menu: MainMenu
    activeId?: string | null
    onClick?: (id: string) => void
  }>(),
  {
    activeId: null,
    onClick: () => {},
  },
)
</script>
<template>
  <ul :class="['menu', { 'is-expanded': activeId }]" role="menubar">
    <li v-for="item in menu" :key="item.id" class="menu-item" role="none">
      <NuxtLink
        :class="[
          'link',
          'text-small',
          'f-bold',
          { 'is-active': item.isActive },
          { 'is-expanded': item.id === activeId },
        ]"
        :to="item.url"
        :aria-expanded="item.id === activeId"
        :aria-current="item.isActive ? 'page' : undefined"
        :aria-controls="`submenu-${item.id}`"
        :data-item-id="item.id"
        role="menuitem"
        tabindex="0"
        @mouseover="onClick(item.id)"
      >
        {{ item.title }}
      </NuxtLink>
    </li>
  </ul>
</template>
<style lang="scss" scoped>
.menu {
  display: flex;
  gap: var(--gap);

  &.is-expanded {
    .link {
      opacity: 0.5;
    }
  }
  @include hover {
    .link {
      opacity: 0.5;
    }
  }
}
.link {
  display: grid;
  place-content: center;
  height: var(--header-bar-height);

  color: var(--c-primary);

  border-bottom: 3px solid transparent;

  @include transitions(opacity, border-color);
  &.is-expanded,
  &.is-active {
    border-color: var(--c-primary);
  }

  &.is-expanded {
    .menu.is-expanded & {
      opacity: 1;
    }
  }

  @include hover {
    border-color: var(--c-primary);
    .menu & {
      opacity: 1;
    }
  }
}
</style>
